// extracted by mini-css-extract-plugin
export default {"title":"NewPromotion_title__R6BaM","boxForm":"NewPromotion_boxForm__ST0lN","form":"NewPromotion_form__AUin7"};